import { CSSProperties } from 'react';
import { Typography } from 'bento';
import { makeStyles } from '@material-ui/core/styles';

export interface BookingDragLayerProps {
  /**
   * Name of the diner.
   */
  name: string;
  /**
   * Optional width style applied to the booking drag layer.
   * Content is truncated if it exceeds the width.
   */
  width?: CSSProperties['width'];
}

const useStyles = makeStyles((theme) => ({
  root: {
    background: theme.colors.bgPrimaryBase,
    borderRadius: 8,
    display: 'inline-flex',
    padding: `${theme.spacing(0.5)}px ${theme.spacing(1)}px`,
  },
}));

/**
 * Drag layer UI for a timeline booking.
 * Note: This component may be generalized for additional usage in future
 */
const BookingDragLayer: React.FC<React.PropsWithChildren<BookingDragLayerProps>> = ({
  name,
  width,
}) => {
  const classes = useStyles();
  const widthStyle = width ? { width } : {};

  return (
    <div className={classes.root} style={widthStyle}>
      <Typography variant="heading04" color="contrast" noWrap>
        {name}
      </Typography>
    </div>
  );
};

export default BookingDragLayer;
